
import { computed, defineComponent, ref, inject } from 'vue';
import { Select, Radio } from '@/components/input-elements';
import InnerLoader from '../../../../../components/InnerLoader.vue';

const MONTONIO_CARRIERS = [
    { label: 'Omniva', value: 'omniva' },
    { label: 'SmartPost', value: 'smartpost' }
];

export default defineComponent({
    name: 'add new shipping method',
    components: {
        Select,
        InnerLoader,
        Radio
    },

    setup(props, context) {
        const emitter: any = inject('emitter');
        const integrationFormRef = ref<null | HTMLFormElement>(null);
        const loader = ref(false);
        const pickups = ref([]) as Record<any, any>;
        const shippingMethod = ref([{ label: 'MONTONIO', value: 'MONTONIO' }]) as Record<any, any>;
        const montonioTypes = ref([{ label: 'Service Point', value: 'SERVICE_POINT' }]) as Record<any, any>;
        const montonioCarriers = ref(MONTONIO_CARRIERS);

        const integrationFormData = ref({
            carriers: '',
            shipping_method: '',
            templates: '',
            types: '',
            address: '',
            is_pickup: 0,
            template_data: ''
        }) as any;

        pickups.value = [
            { label: 'message.YES', value: 1 },
            { label: 'message.NO', value: 0 }
        ];

        const isMontonioServicePoint = computed(
            () => integrationFormData.value.shipping_method === 'MONTONIO' && integrationFormData.value.is_pickup == 1
        );

        const resetMontonioIntegrationFields = () => {
            integrationFormData.value.templates = '';
            integrationFormData.value.template_data = '';
            integrationFormData.value.carriers = '';
            integrationFormData.value.types = '';
            integrationFormData.value.address = '';
            integrationFormData.value.is_pickup = 0;
        };

        const applyMontonioServicePointDefaults = () => {
            integrationFormData.value.types = 'SERVICE_POINT';
            integrationFormData.value.templates = '';
            integrationFormData.value.template_data = '';
            integrationFormData.value.address = '';
        };

        const onShippingMethodChange = () => {
            if (integrationFormData.value.shipping_method === 'MONTONIO') {
                return;
            }
            resetMontonioIntegrationFields();
            integrationFormData.value.shipping_method = integrationFormData.value.shipping_method || '';
        };

        const changePickUp = () => {
            if (integrationFormData.value.is_pickup == 1) {
                applyMontonioServicePointDefaults();
                return;
            }
            integrationFormData.value.carriers = '';
            integrationFormData.value.types = '';
        };

        const validateForm = () => {
            let valid = true;
            integrationFormRef.value?.validate(validated => {
                valid = validated;
            });

            const model = integrationFormRef.value?.model;
            if (
                model?.shipping_method === 'MONTONIO' &&
                model?.is_pickup == 1 &&
                model?.types === 'SERVICE_POINT' &&
                !model?.carriers
            ) {
                valid = false;
            }

            if (valid) {
                if (model?.shipping_method === 'MONTONIO') {
                    integrationFormData.value.types = model.is_pickup == 1 ? 'SERVICE_POINT' : '';
                    integrationFormData.value.templates = '';
                    integrationFormData.value.template_data = '';
                }
                context.emit('store', 'integrationFormData', integrationFormData.value);
                return true;
            }
            return false;
        };

        const resetForm = () => {
            emitter.emit('clearInput');
            integrationFormRef.value?.resetFields();
            resetMontonioIntegrationFields();
            integrationFormData.value.shipping_method = '';
        };

        const editShippingMethodValue = (shippingData: Record<any, any>) => {
            resetForm();
            const integration = shippingData?.shipping_method_integration;
            integrationFormData.value.carriers = integration?.shipping_method_service_point_carrier?.carrier || '';
            integrationFormData.value.shipping_method = integration?.shipping_method || '';
            integrationFormData.value.types = integration?.type || '';
            integrationFormData.value.is_pickup = integration?.is_pickup ? integration.is_pickup : 0;
            integrationFormData.value.templates = integration?.template_id || '';
            integrationFormData.value.template_data = integration?.template_data || '';

            if (integrationFormData.value.shipping_method === 'MONTONIO' && integrationFormData.value.is_pickup == 1) {
                applyMontonioServicePointDefaults();
                integrationFormData.value.carriers = integration?.shipping_method_service_point_carrier?.carrier || '';
            }
        };

        return {
            integrationFormData,
            integrationFormRef,
            shippingMethod,
            montonioTypes,
            montonioCarriers,
            pickups,
            loader,
            isMontonioServicePoint,
            editShippingMethodValue,
            validateForm,
            changePickUp,
            onShippingMethodChange
        };
    }
});
